import SvgIcon from "@mui/material/SvgIcon";

const ChevronLeft = props => {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
    </SvgIcon>
  );
};

export default ChevronLeft;
